import React, { Component } from "react";
import { withRouter } from "react-router";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import queryString from "query-string";
import moment from "moment";
import ls from 'localstorage-slim';
import { toast } from 'react-toastify';
import axios from "../../../../../axios-instance";

import Icon from "../../../../../components/UI/Icon/Icon";
import { Stepper } from "../../../../../components/Stepper/Stepper";
import GuestModal from "./GuestModal/GuestModal";

import {
  FillFields,
  SelectTickets,
} from "../../../../OpenSell/Steps";
import { ChoosePaymentMethod } from "./Steps/ChoosePaymentMethod";

import ROUTES from "../../../../../constants/routes";
import { fee } from "../../../../SeasonPass/constants";
import { currencies } from "../../../../../constants/currencies";

import { getHeaders } from "../../../../../helpers/getHeaders";
import { filterUnavailableTicketTemplates } from "../../../../../helpers/filterUnavailableTicketTemplates";
import { showErrorModal } from "../../../../../modals";

import PleaseWait from "../../../../../images/please-wait-season-pass-modal.svg";
import ThanksForYourPurchase from "../../../../../images/thanks-for-your-purchase.svg";

import "../../../../OpenSell/OpenSell.sass";
import { isValidEmail } from "../../../../../helpers/validators";
import Select from "react-select";
import { FramedLabel } from "../../../../../components/FramedLabel/FramedLabel";
import NewLoader from "../../../../../components/NewLoader/NewLoader";
import { ticketTypes } from "../../../../../helpers/ticketHelper.ts";
import { getOc } from "../../../../../helpers/optionalChain.ts";
import { applyDiscounts, getPrice, getTotalFee } from "../../../../../helpers/ticketPriceHelper.ts";
import { getRegion } from "../../../../../helpers/getRegion";
import "./EventSell.sass";
import { getCustomURLs } from "../../../../../helpers/getCustomURLs.js";
import PleaseWaitModal from "../../../../BarCodes/modals/PleaseWaitModal.js";
import { loadFile } from "../../../../../helpers/loadFile.js";
import { getVisibleBankLogos } from "../../../../../helpers/getVisibleBankLogos.js";
import { getFieldKeyName } from "../../../../../helpers/getFieldKeyName.js";

const MySwal = withReactContent(swal);

const initialState = {
  fields: {
    fullName: "",
    physicalAddress: "",
    city: "",
    postalCode: "",
    phoneNumber: "",
    buyerEmail: "",
    birthday: null,
    gender: "",
    generationTitle: "",
    companyName: "",
    paymentType: "",
    companyVatNumber: "",
    buyerCountry: "",
  },
  tickets: [],
  canAddTickets: true,
  transactionData: {
    orderId: "",
    paymentAmount: 0,
    currencyCode: "RSD",
  },
  eventData: {
    ticketTemplates: [],
    reservations: [],
    allowedPaymentProviders: [],
  },
  offers: [],
  fieldTheme: [],
  step: 1,
  // UI color for page
  themeColor: "#6071B5",
  hasSeats: undefined,
  feeRate: fee,
  fixedFeeRate: 0,
  loading: true,
  submittBlocked: false,
  reservationsOptions: [],
  selectedReservation: 'Reservation',
  reservationOperationLoading: false,
  chart: null,
  mixedTickets: true,
  manualDiscount: 0,
  allowManualDiscount: true,
  isPageLoaded: false,
  isNextStepLoading: false,
};

class Sell extends Component {
  state = initialState;

  formRef = React.createRef();

  handleChangeStep = async (nextStep) => {
    const tickets = [...this.state.tickets];
    const chart = this.state.chart;
    this.setState({ isNextStepLoading: true });

    try {
      if (this.state.step === 1 && chart) {
        await chart.clearSelection();
        tickets.forEach(t => {
          this.onTicketAdded(t)
        })
        this.setState({canAddTickets: false})
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ step: nextStep, isNextStepLoading: false });
    }
  };

  setOrderDataToState = (data) => {
    const fields = {
      ...this.state.fields,
      fullName: data.fullName,
      physicalAddress: data.physicalAddress,
      city: data.city,
      postalCode: data.postalCode,
      phoneNumber: data.phoneNumber,
      buyerEmail: data.buyerEmail,
      buyerCountry: data.buyerCountry,

      birthday: data.birthday ? new Date(data.birthday) : null,
      gender: data.gender,
      companyName: data.companyName,
      companyVatNumber: data.companyVatNumber,
    };

    this.setState({
      fields,
    });
  };

  componentWillUnmount() {
    MySwal.close();
  }

  showPleaseWaitModal = () => {
    MySwal.fire({
      imageUrl: PleaseWait,
      title: "Please wait",
      text: "You will be redirected to the payment page",
      allowEscapeKey: false,
      customClass: "seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  showOfferConfirmationModal = (foo, relatedOffers, confirmButtonText) => {
    MySwal.fire({
      title: "Are you sure?",
      html: `
      You have selected the offered seats.
      <br/>
      Any actions with this seats will change existing offer
      <br/>
      <br/>
      Related offers: <ul style="line-height: 2rem;">${relatedOffers.reduce((a, i) => {
        return a + `<li style="text-align: left;"><strong>${i.seatLabel}</strong> for ${i.fullName} ${i.email}</li>`
      }, '')}</ul>`,
      allowEscapeKey: true,
      customClass: "seasonpass__modal partizan-info-modal",
      allowOutsideClick: true,
      allowEnterKey: false,
      reverseButtons: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: "Cancel",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(foo);
  };

  getOrderData = async () => {
    try {
      const { data } = await axios.get(
        `Transaction/${this.props.match.params.orderId}`
      );
      if (data) {
        this.handleOrderStatuses(data);
        this.setOrderDataToState(data);
      }
    } catch (e) {
      showErrorModal({
        text: `It seems to have failed to complete the payment, please try again`,
        showConfirmButton: false,
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      });
      console.log(e);
    }
  };

  setPrice = () => {
    const { tickets, eventData, manualDiscount } = this.state;

    applyDiscounts(tickets, eventData.ticketTemplates);

    for (const ticket of tickets) {
        ticket.fixedDiscount = manualDiscount;
      }

    // if (!!manualDiscount || manualDiscount === 0) {
    //   const getDiscount = (originalPrice, discount) =>
    //     originalPrice >= discount
    //       ? [discount, 0]
    //       : [originalPrice, discount - originalPrice]

    //   let prevDiscount = manualDiscount;

    //   for (const ticket of tickets) {
    //     ticket.fixedDiscount = 0;
    //     const [disc, last] = getDiscount(ticket.getPrice(), prevDiscount);
    //     prevDiscount = last;

    //     ticket.fixedDiscount = disc;
    //   }
    // }

    this.setTransactionData({
      paymentAmount: getPrice(tickets, eventData.ticketTemplates, null, 0),
    });
  };

  handleOrderStatuses = (data) => {
    if (!this.state.isPageLoaded) {
      return;
    }

    const { API_URL } = getCustomURLs();
    const link = data.ticketResultGuid ? (
      <a
        className="sell__info-modal-link"
        target="__blank"
        href={`${API_URL}/Transaction/Ticket/${data.ticketResultGuid}?usedCached=true`}
      >
        Generated Pdfs
      </a>
    ) : (
      ""
    );

    const additionalText = data.ticketResultGuid
      ? `(Payment Status: ${data.additionalPaymentStatus
      }, Payment Date: ${moment(data.paymentDate).format(
        "DD MMMM YYYY HH:mm"
      )}, Transaction Id: ${data.transactionId})`
      : "";

    MySwal.fire({
      html: (
        <div className="season-pass-info-modal">
          <div className="season-pass-info-modal__body">
            <h3>Thanks for Your Purchase!</h3>
            <img src={ThanksForYourPurchase} alt="Thanks For Your Purchase" />
            <p>We will send all the details to your inbox <b>{data.buyerEmail}</b> and look forward to meeting you</p>
            {this.props.additionalText && (
              <p className="season-pass-info-modal__additionalText">
                {additionalText}
              </p>
            )}
            {link}
          </div>
        </div>
      ),
      width: "900px",
      allowEscapeKey: false,
      padding: "0px 0px 48px 0px",
      customClass: "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: true,
      confirmButtonText: "Buy More",
    }).then((result) => {
      if (result) {
        const eventId = this.props.match.params.id;
        this.props.history.push({
          pathname: ROUTES.NEW_EVENT_SELL.replace(":id", eventId).replace(
            ":orderId?",
            ""
          ),
        });
      }
    });
  };

  setTransactionData = (data) => {
    const paymentAmount = data.paymentAmount;

    const orderId = data.orderId || this.state.transactionData.orderId || "";

    const transactionData = {
      ...this.state.transactionData,
      ...data,
      orderId,
    };

    if (paymentAmount) {
      const total = paymentAmount + paymentAmount * this.state.feeRate + this.state.fixedFeeRate * this.state.tickets.length;

      transactionData.paymentAmount = total;
    }

    this.setState({
      transactionData,
    });
  };

  showGuestModal = (ticketTemplateIds, generationTitle, ticketTemplates) => {
    MySwal.fire({
      html: (
        <GuestModal
          title={"Thanks for Your Purchase!"}
          ticketTemplateIds={ticketTemplateIds}
          generationTitle={generationTitle}
          ticketTemplates={ticketTemplates || []}
        />
      ),
      width: "900px",
      customClass:
        "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      allowEscapeKey: false,
      padding: "0px 0px 48px 0px",
      allowOutsideClick: false,
      allowEnterKey: false,
      confirmButtonText: "Buy More",
      showConfirmButton: true,
    }).then(() => {
      const eventId = this.props.match.params.id;
      this.props.history.push({
        pathname: ROUTES.NEW_EVENT_SELL.replace(":id", eventId).replace(":orderId?", ""),
      });
      window.location.reload();
    });
  };

  checkGuestParams = () => {
    const { ticketTemplateIds, generationTitle } = queryString.parse(
      this.props.location.search
    );
    const { eventData } = this.state;

    if (!ticketTemplateIds || !generationTitle) {
      return false;
    }

    const parsedTicketTemplateIds = atob(ticketTemplateIds);
    const parsedGenerationTitle = atob(generationTitle);

    this.showGuestModal(
      parsedTicketTemplateIds.split(","),
      parsedGenerationTitle,
      eventData.ticketTemplates
    );

    return true;
  };

  guestCreate = (seats = []) => {
    const { generationTitle } = this.state.fields;

    const eventId = this.props.match.params.id;

    const uniqueIds = new Set();

    const ticketTemplateIds = seats
      .filter((item) => {
        if (!uniqueIds.has(item.ticketTemplateId)) {
          uniqueIds.add(item.ticketTemplateId);
          return true;
        }
        return false;
      })
      .map((item) => item.ticketTemplateId)
      .join(",");

    const params = {
      ticketTemplateIds: btoa(ticketTemplateIds),
      generationTitle: btoa(generationTitle),
    };

    const queryParams = queryString.stringify(params, { encode: false });

    this.props.history.push({
      pathname: `${ROUTES.NEW_EVENT_SELL.replace(":id", eventId).replace(
        ":orderId?",
        ""
      )}?${queryParams}`,
    });

    this.checkGuestParams();
  };

  createOrder = async () => {
    const {
      fields: {
        paymentType,
        birthday,
        generationTitle,
        ...otherFields
      },
      transactionData,
      tickets,
      fieldTheme,
    } = this.state;

    let seats = tickets.map(t => {
      return {
        ticketTemplateId: t.ticketTemplateId,
        area: t.area,
        side: t.side,
        row: t.row,
        seat: t.seat,
        optionalParameters: t.optionalParameters,
        fixedDiscount: (t.fixedDiscount).toFixed(2),
      }
    });

    const eventId = this.props.match.params.id;

    const body = {
      transaction: {
        ...otherFields,
        currency: transactionData.currencyCode,
        amount: transactionData.paymentAmount,
        birthday: birthday ? birthday : undefined,
        seats,
        paymentType: paymentType,
        transactionFieldValues: fieldTheme
          .filter((f) => f.type === 0)
          .map((f) => ({
            value: otherFields[f.name] || '',
            transactionAddtitionalFieldId: f.id,
          })),
      },
    };

    const user = JSON.parse(localStorage.getItem("user"));

    const params = {
      generationTitle,
    };

    const queryParams = queryString.stringify(params, { encode: false });

    const { data: orderId } = await axios.post(
      `ManageTransactions/CreateAndSell?${queryParams}`,
      body,
      {
        headers: getHeaders(user.token),
      }
    );

    if (paymentType === 4) {
      this.guestCreate(seats);
      return;
    }

    this.setTransactionData({
      orderId,
    });

    this.props.history.push({
      pathname: ROUTES.NEW_EVENT_SELL.replace(":id", eventId).replace(":orderId?", orderId),
    });
  };

  handleSubmit = async () => {
    try {
      this.showPleaseWaitModal();
      await this.createOrder();

      ls.set("isSeatSelected", true);
      if (this.state.fields.paymentType !== 4) window.location.reload();
    } catch (e) {
      console.log(e);
      showErrorModal({
        text: `It seems to have failed to complete the payment, please try again`,
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      });
    }
  };

  handleChange = (name, value) => {
    if (name) {
      this.setState({ fields: { ...this.state.fields, [name]: value } });
    }
  };

  checkActionButtonDisabled = () => {
    const {
      step,
      fields: {
        paymentMethod,
        paymentType,
        generationTitle,
        buyerEmail,
        birthday,
        phoneNumber,
        ...otherFields
      },
      submittBlocked,
      tickets,
      loading,
      fieldTheme,
    } = this.state;

    if (submittBlocked || loading || tickets.some(t => t.fixedDiscount > t.amount)) return true;

    switch (step) {
      case 1:
        return !tickets.length;
      case 3:
        if (paymentType === 1) {
          return !paymentType;
        }
        if (paymentType === 4) {
          return !generationTitle || !paymentType;
        }
        return !paymentType;
      case 2:
        return !isValidEmail(buyerEmail);
        
        //Disable validation fields for internal selling page

        // if (!isValidEmail(buyerEmail)) return true;
        // return (
        //   !fieldTheme.every((ft) => {
        //     if (ft.type === 0 && ft.isRequired) {
        //       return !!otherFields[ft.name];
        //     }

        //     if (ft.isRequired && getFieldKeyName(ft.name) in otherFields) {
        //       return !!otherFields[getFieldKeyName(ft.name)];
        //     }
        //     return true;
        //   })
        //   || (fieldTheme.find((ft) => ft.type === 2) && fieldTheme.find((ft) => ft.type === 2).isRequired ? !moment(birthday).isValid() : false)
        //   || (fieldTheme.find((ft) => ft.type === 6) && fieldTheme.find((ft) => ft.type === 6).isRequired ? (!phoneNumber || phoneNumber.length < 5) : false)
        // )
      default:
        return false;
    }
  };

  onTicketAdded = (ticket) => {
    if (!this.state.canAddTickets) return;

    if (ticket.type === ticketTypes.NO_SEAT) {
      const tickets = [...this.state.tickets, ticket];

      this.setState({ tickets }, () => this.setPrice());

      return;
    }

    if (
      this.state.chart && !ticket.masterTicket &&
      this.state.tickets.some(t => t.label === ticket.label) && 
      ticket.type === ticketTypes.MAP
    ) {
      return;
    }

    const tickets = [...this.state.tickets];
    if (ticket.type === ticketTypes.NFC) {
      if (ticket.masterTicket) {
        const masterTicketIdx = this.state.tickets.findIndex((t) =>
          t.id === ticket.masterTicket.id
        );
        tickets.splice(masterTicketIdx + 1, 0, ticket)
      }
    }
    else {
      tickets.push(ticket);
    }

    this.setState({ tickets }, () => this.setPrice());
  };

  onTicketRemoved = (ticket, manual = false) => {

    if (this.state.chart && ticket.type === ticketTypes.MAP) {
      this.state.chart.deselectObjects([ticket.label]);
    }

    if (this.state.chart && ticket.type === ticketTypes.MAP_NO_SEAT && manual) {
      this.state.chart.deselectObjects([{ label: ticket.label, amount: 1 }]);
      return;
    }

    if (ticket.type === ticketTypes.NO_SEAT) {
      const index = this.state.tickets.findIndex(i => i.ticketTemplateId === ticket.ticketTemplateId);

      this.setState(
        {
          tickets: this.state.tickets.filter((item, i) => i !== index),
        },
        () => this.setPrice()
      );
    }
    else if (ticket.type === ticketTypes.MAP_NO_SEAT) {
      const index = this.state.tickets.findIndex(i => i.label === ticket.label);
      this.setState(
        {
          tickets: this.state.tickets.filter((item, i) => i !== index),
        },
        () => this.setPrice()
      );
    }
    else if (ticket.type === ticketTypes.MAP) {
      this.setState(
        {
          tickets: this.state.tickets
            .filter((t) => t.id !== ticket.id && getOc(t, 'masterTicket?.id') !== ticket.id),
        },
        () => this.setPrice()
      );
    }
    else if (ticket.type === ticketTypes.NFC) {
      this.setState(
        {
          tickets: this.state.tickets
            .filter((t) => t.id !== ticket.id),
        },
        () => this.setPrice()
      );
    }
  };

  getEventData = async () => {
    try {
      const eventId = this.props.match.params.id;
      if (!eventId) throw Error();

      const user = JSON.parse(localStorage.getItem("user"));

      document.documentElement.style.setProperty(
        "--partizan-theme",
        this.state.themeColor
      );

      const { data } = await axios.get(`EventPublicInfo/${eventId}`);

      data.ticketTemplates = filterUnavailableTicketTemplates(
        data.ticketTemplates
      );

      data.reservations.push({
        label: 'Open Sell',
        availableSeats: data.totalAvailableSeats - data.reservations.reduce((acc, curVal) => acc + curVal.availableSeats, 0),
        channelKey: 'NO_CHANNEL',
      })

      data.reservations = [{
        label: 'All' + ' (' + data.totalAvailableSeats + ')',
        availableSeats: data.totalAvailableSeats,
        channelKey: data.reservations.map((r) => r.channelKey)
      }, ...data.reservations.map(r => { return { ...r, channelKey: [r.channelKey], label: r.label + ' (' + r.availableSeats + ')' } })];

      const { data: offersData } = await axios.get(`ManageTransactions/${eventId}/Offers`, { headers: getHeaders(user.token) });

      this.setState({
        transactionData: {
          ...this.state.transactionData,
          currencyCode: currencies.find(
            ({ value }) => value === data.currencyId
          ).label,
        },
        hasSeats: data.ticketTemplates.length
          ? data.ticketTemplates.filter(t => t.hasSeats) >= data.ticketTemplates.filter(t => !t.hasSeats)
          : undefined,
        feeRate: data.feeRate || fee,
        fixedFeeRate: data.fixedFeeRate || 0,
        eventData: data,
        fieldTheme: data.transactionFields,
        offers: offersData,
        reservationsOptions: data.reservations.map(r => {
          return {
            value: r.label,
            label: r.label,
          }
        })
      });
    } catch (e) {
      showErrorModal({
        text: `It seems to have failed to complete the payment, please try again`,
        showConfirmButton: false,
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      });
      console.log(e);
    }
  };

  callAPIs = async () => {
    const orderId = this.props.match.params.orderId;
    this.setState({ loading: true });

    await this.getEventData();

    if (this.checkGuestParams()) {
      return;
    }

    if (orderId) await this.getOrderData();

    this.setState({ loading: false });
  };

  setReservationLoading = (value) => {
    this.setState({
      ...this.state,
      reservationOperationLoading: value,
    })
  }

  clearSelection = async (rerender = false) => {
    const chart = this.state.chart

    if (chart) {
      await chart.clearSelection();

      if (rerender) {
        chart.rerender();
      }
    }
  }

  reserveSeats = async (comments) => {
    this.setReservationLoading(true);

    const channelId = this.state.eventData.reservations.find(r => r.label.startsWith('Reservation')).id;
    const user = JSON.parse(localStorage.getItem("user"));

    const seatsToProcessing = this.state.tickets.map(t => t.label);

    await axios.post(
      '/Reservation/assign',
      {
        comments: comments,
        reservationChannelId: channelId,
        seats: seatsToProcessing,
      },
      {
        headers: getHeaders(user.token),
      },);

    await this.clearSelection(true);

    this.setReservationLoading(false);
  }

  unreserveSeats = async () => {
    this.setReservationLoading(true);

    const user = JSON.parse(localStorage.getItem("user"));

    const seatsToProcessing = this.state.tickets.map(t => t.label);

    await axios.post(
      '/Reservation/unreserve',
      {
        eventId: this.state.eventData.eventId,
        seats: seatsToProcessing,
      },
      {
        headers: getHeaders(user.token),
      },);

    await this.clearSelection(true)

    this.setReservationLoading(false);
  }

  setChart = (c) => {
    this.setState(
      {
        ...this.state,
        chart: c,
      }
    )
  }

  getChannels = () => {
    let channels = this.state.eventData.reservations.find(r => r.label.startsWith(this.state.selectedReservation))

    if (channels) {
      channels = channels.channelKey;
    }

    return !!channels ? channels : ['NO_CHANNEL'];
  }

  getSelectedOffers = () => {
    let offerChannel = this.state.eventData.reservations.find(r => r.label.startsWith('Offers'));

    offerChannel = offerChannel && offerChannel.channelKey[0];
    const offeredSeats = this.state.tickets.filter(t => getOc(t, 'isInChannel', () => false)(offerChannel)).map(t => t.label);

    return this.state.offers.filter(o => offeredSeats.includes(o.seatLabel))
  }

  downloadDataAsFile = (data, name) => {
    if (data) {
      loadFile(data, name);

      toast.success('File downloaded successfully');
    } else {
      toast.error('Failed to retrieve data');
    }
  };

  downloadReportHandler = async () => {
    const { selectedReservation, eventData } = this.state;

    const user = JSON.parse(localStorage.getItem("user"));
    const eventId = eventData.eventId;

    const channels = {
      0: "All",
      1: "Reservation",
      2: "Offers",
      3: "Reselling",
      4: "Open Sell",
    }

    let channel = 1

    for (const key in channels) {
      if (selectedReservation.startsWith(channels[key])) {
        channel = key;
      }
    }

    try {
      try {
        MySwal.fire({
          html: <PleaseWaitModal message='Downloading file…' />,
          customClass: 'please-wait-modal',
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        const { data } = await axios.get(
          `EventReports/ByChannel?asCsv=true&eventId=${eventId}&mapChannel=${channel}`,
          { headers: getHeaders(user.token) }
        );

        this.downloadDataAsFile(data, `Seats_${channels[channel]}_${eventData.eventName}.csv`);
      } finally {
        MySwal.close();
      }
    } catch (e) {
      toast.error('File was not downloaded');
      console.log(e);
    }
  }

  componentDidUpdate(oldProps, oldState) {
    if (this.state.step === 1) {
      if (
        this.state.chart
        && oldState.chart
        && this.state.chart.state !== oldState.chart.state
        && oldState.tickets
      ) {
        const labels = this.state.tickets.map(t => t.label)
        this.state.chart.trySelectObjects(labels);
      }
    }

    if (oldState.coupon !== this.state.coupon) {
      this.setPrice();
    }
  }

  componentDidMount() {
    this.callAPIs();

    this.setState({ isPageLoaded: true, });
  }

  checkOfferConfirmation = (func, confirmButtonText, comments) => {
    const offers = this.getSelectedOffers();

    if (offers.length) {
      this.showOfferConfirmationModal(r => 'value' in r ? func(comments) : () => { }, offers, confirmButtonText);
    }
    else {
      func(comments);
    }
  }

  allowAddTicket = () => {
    window.setTimeout(() => this.setState({ canAddTickets: true, }), 1000)
  }

  render() {
    const {
      step,
      fields,
      tickets,
      transactionData,
      eventData,
      loading,
      hasSeats,
      feeRate,
      fixedFeeRate,
      reservationsOptions,
      selectedReservation,
      manualDiscount,
      allowManualDiscount,
      isNextStepLoading,
      fieldTheme,
    } = this.state;

    const time = moment(eventData.startDate).format("DD.MM.YYYY HH:mm");

    const pricing = eventData.ticketTemplates.map(({ ticketTemplateId, categoryKey, price }) => ({
      category: categoryKey,
      ticketTemplateId: ticketTemplateId,
      price,
    }));

    const prefixLabel = eventData.prefixLabel || "";
    const region = getRegion();

    const location = eventData.place || "";
    const totalFee = getTotalFee(tickets, fixedFeeRate, feeRate, eventData.ticketTemplates, null, 0);

    const visibleBankLogos = getVisibleBankLogos(eventData);

    const steps = [
      {
        title: "Select Tickets",
        component: (
          <>
            {hasSeats &&
              <div className="stepper__reservation-wrapper">
                <FramedLabel
                  label='Reservation options'
                  className='reservation-options'
                >
                  <Select
                    options={reservationsOptions}
                    name="reservationChannel"
                    value={(() => {
                      const selected = reservationsOptions.find(
                        ({ label }) => label.startsWith(selectedReservation) 
                      );
                      return selected
                    })()}
                    onChange={async (value) => {
                      await this.clearSelection();
                      this.setState({
                        ...this.state,
                        selectedReservation: value.label,
                      })
                    }}
                    classNamePrefix="custom-select"
                    className="partizan-open-selling__select"
                  />
                  <button onClick={async (e) => {
                    e.preventDefault();
                    // const { value: comments } = await MySwal.fire({
                    //   title: 'Enter comments',
                    //   input: 'textarea',
                    //   inputLabel: 'Comments',
                    //   inputPlaceholder: 'Reservation comments',
                    //   cancelButtonText: "No comments",
                    //   showCancelButton: true,
                    //   inputValidator: (value) => {
                    //     if (false) {
                    //       return 'You need to write something!';
                    //     }
                    //   }
                    // });
                    // this.checkOfferConfirmation(this.reserveSeats, "Reserve", comments)
                    this.checkOfferConfirmation(this.reserveSeats, "Reserve")
                  }}
                    className="btn-primary"
                    disabled={!tickets.length}>
                    Reserve</button>
                  <button onClick={(e) => {
                    e.preventDefault();
                    this.checkOfferConfirmation(this.unreserveSeats, "Open to sale")
                  }}
                    className="btn-primary"
                    disabled={!tickets.length}>
                    Open to sale
                  </button>
                  {this.state.reservationOperationLoading
                    && <NewLoader onClick={e => e.preventDefault()} />}
                </FramedLabel>

                <button
                  type="button"
                  className='btn-primary report-button'
                  onClick={this.downloadReportHandler}
                >
                  Download Report
                </button>
              </div>
            }

            <SelectTickets
              maxSelectedObjects={100}
              fixedFeeRate={fixedFeeRate * tickets.length}
              totalFee={totalFee}
              tickets={tickets}
              ticketTemplates={eventData.ticketTemplates}
              pricing={pricing}
              hasSeats={hasSeats}
              workspaceKey={eventData.hideSeatsIoWorkspaceId}
              eventSeatsId={eventData.hideSeatsIoEventId}
              event={eventData}
              loading={loading}
              currency={transactionData.currencyCode}
              onObjectSelected={this.onTicketAdded}
              onObjectDeselected={this.onTicketRemoved}
              total={transactionData.paymentAmount}
              channels={this.getChannels()}
              showInfo={true}
              onSetChart={this.setChart}
              offers={this.state.offers}
              allowEnterCouponCode={false}
              reservations={this.state.eventData.reservations.filter(r => !r.label.startsWith('All')).map(r => {
                return {
                  label: r.label,
                  channelKey: r.channelKey[0],
                }
              })}
              multiSelectEnabled={true}
              allowManualDiscount={allowManualDiscount}
              manualDiscount={manualDiscount}
              setManualDiscount={(value) => {
                this.setState(
                  {
                    ...this.state,
                    manualDiscount: Number(value)
                  }, () => this.setPrice())
              }}
              isTermsCheckbox={false}
              isNextStepLoading={isNextStepLoading}
              allowSelectNfc={true}
              allowAddTicket={this.allowAddTicket}
            />
          </>
        ),
      },
      {
        title: "Fill in the info",
        component: (
          <FillFields
            fields={fields}
            requiredFields={["buyerEmail"]}
            shouldCheckCheckboxes={false}
            handleChange={this.handleChange}
            fieldTheme={fieldTheme}
          />
        ),
      },
      {
        title: "Buy tickets",
        component: (
          <ChoosePaymentMethod
            totalFee={totalFee}
            fields={fields}
            hasSeats={hasSeats}
            currency={transactionData.currencyCode}
            email={fields.buyerEmail}
            tickets={tickets}
            total={transactionData.paymentAmount}
            paymentType={fields.paymentType}
            handleChange={this.handleChange}
            allowEnterCouponCode={false}
            onObjectDeselected={this.onTicketRemoved}
          />
        ),
      },
    ];

    const headerComponent = (
      <div>
        <h2 className="partizan-open-selling__stepper-header-event-name">
          {prefixLabel}
        </h2>
        <h2 className="partizan-open-selling__stepper-header-title">
          {eventData.eventName}
        </h2>
        <h5 className="partizan-open-selling__stepper-header-subtitle">
          Supported by {region.title}
        </h5>
        <div className="partizan-open-selling__stepper-header-info">
          <div className="partizan-open-selling__stepper-header-info-location">
            <Icon name={"map-pin-solid"} />
            <p>{location}</p>
          </div>
          <p className="partizan-open-selling__stepper-header-info-time">
            {time}
          </p>
        </div>
      </div>
    );

    const actionComponent = (
      <div className="partizan-open-selling__stepper-action">
        <div className="partizan-open-selling__stepper-action-btns">
          {step === 1 ? <span></span> : (
            <button
              className="btn-secondary"
              type="button"
              onClick={() => this.handleChangeStep(step - 1)}
            >
              Previous
            </button>
          )}
          {steps.length === step && (
            <button
              className="btn-primary"
              type="button"
              disabled={this.checkActionButtonDisabled()}
              onClick={this.handleSubmit}
            >
              Create
            </button>
          )}
          {steps.length !== step && (
            <button
              className="btn-primary"
              type="button"
              disabled={this.checkActionButtonDisabled()}
              onClick={() =>
                (step === 1)
                  ? this.checkOfferConfirmation(() => this.handleChangeStep(step + 1), "Next")
                  : this.handleChangeStep(step + 1)}
            >
              Next
            </button>
          )}
        </div>
        <div className="seasonpass__bank-logos">
          {visibleBankLogos.map(({ alt, src, link }) => (
            <div key={alt}>
              <a target="_blank" rel="noopener noreferrer" href={link}>
                <img style={{ height: 30 }} src={src} alt={link} />
              </a>
            </div>
          ))}
        </div>
      </div >
    );

    return (
      <div className="partizan-open-selling new-event__sell sell">

        <form ref={this.formRef} className="partizan-open-selling__wrapper">
          <div className="partizan-open-selling__logo seasonpass__header-logo-wrapper">
            <img src={`/${region.theme}/logo.png`} alt="Logo" />
            <h2>{region.title}</h2>
          </div>

          <Stepper
            headerStyle={{
              backgroundImage:
                `url(${window.screen.width <= 480 && eventData.mobileImageUrl
                  ? eventData.mobileImageUrl
                  : eventData.imageUrl}
                )`,
            }}
            headerWrapperClass="partizan-open-selling__stepper-header"
            headerComponent={headerComponent}
            actionComponent={actionComponent}
            currentStep={step}
            steps={steps}
          />

        </form>

      </div >
    );
  }
}

export default withRouter(Sell);
